<template>
    <div v-if="showDialog"
    class="fixed inset-0 bg-white z-50 flex flex-col items-start justify-start p-6 overflow-y-auto"
    @mouseleave="goBack">
        <div class=" w-full mx-auto ">
         
            <div >
          <div class="flex justify-between">
            <div>
                <svg v-if="showCategoryTypes" @click="goBackToCategories" class="h-6 w-6 text-blue"  fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"/>
                  </svg>
                  
            </div>
            <div>
                <h3 class="text-lg text-center font-semibold ">{{ selectedCategoryName }}</h3>
            </div>
            <div class="float-right">
                <svg  @click="goBack" class="h-6 w-6 text-blue" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                </svg>
              </div>
          </div>
          <div class="flex flex-row  "> 
            <!-- Ensure all items are in a row -->
            <div v-if="showDialog && showCategories" class="w-full md:w-3/4  dark:bg-gray-800 ">
              <div v-for="category in categories" :key="category.id" class=" hover:bg-sky-100 group border-t-2 border-grey-200 ">
                <div class="flex justify-between items-center">
                  <CategoryBox :category="category" @category-clicked="fetchCategoryTypes(category)" />
                  <svg class="w-4 h-4 text-gray-800 dark:text-white hidden group-hover:block" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 8 14">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 13 5.7-5.326a.909.909 0 0 0 0-1.348L1 1"/>
                  </svg>
                </div>
              </div>
            </div>
  <!-- Main content -->
<main v-if="showDialog && showCategoryTypes" class="w-full md:flex-1 max-w-3xl">
    <img :src="selectedCategoryImageUrl" 
         alt="Category Image" 
         class="mt-4  object-cover h-48 w-full">
    <h3 class="mt-4 text-lg font-semibold">{{ selectedCategoryName }}</h3>

    <div v-if="categoryTypes.length > 0" class="pr-4 border-t-2 border-gray-200">
        <ul class="list-none">
            <li v-for="type in categoryTypes" :key="type.id" class=" dark:bg-gray-700 group p-2 rounded-lg mb-2">
                <div class="flex flex-col">
                    <p class="text-md font-semibold">{{ type.nom }}</p>

                    <div class="border-t-2 border-gray-200 ">
                        <ul class="flex flex-col list-none ">
                            <li v-for="produit in type.produits" :key="produit.id" class=" mb-1  hover:bg-sky-100 shadow-sm hover:text-blue hover:underline flex items-center justify-between">
                              <a @click="gogo(produit.id)" class="mr-2">{{ produit.nom }}</a>
                              
                              <svg class="w-2 h-2 text-gray-800 dark:text-white hidden group-hover:block" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 8 14">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 13 5.7-5.326a.909.909 0 0 0 0-1.348L1 1"/>
                                </svg>
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</main>

  
           
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import CategoryBox from './CategoryBox.vue';
  import axios from 'axios';
  
  export default {
    name: 'categoryMenu',
    components: {
      CategoryBox,
    
    },

    props: {
      modalBackdropClass: {
        type: String,
        default: '',
      },
      dialogClass: {
        type: String,
        default: '',
      },
      class: {
        type: String,
        default: '',
      },
      showDialog: {
    type: Boolean,
    default: false,
  },
    },
    data() {
      return {
        categories: [],
        categoryTypes: [],
        produits: [],
        selectedCategoryName: null,
        selectedCategoryId: null,
        selectedCategoryTypeName: null,
        selectedCategoryImageUrl: null,
        propValue: 'someValue',
        showCategories: true,
        showCategoryTypes: false,
        showProducts: false,
        isMobile: window.innerWidth <= 768
      };
    },
    methods: {
   
    
    
  
      gogo(productId) {
      this.$router.push({ name: 'ProductDetails', params: { id: productId } });
      this.$emit('update:showDialog', false); // Add this line to emit an event to the parent

    },
      async fetchCategories() {
        try {
          const response = await axios.get('https://scap.ma/api/category');
          this.categories = response.data;
        } catch (error) {
          console.error(error);
        }
      },
      async fetchCategoryTypes(category) {
        this.selectedCategoryName = category.nom;
        this.selectedCategoryImageUrl = category.image; // This line sets the image URL

        this.categoryTypes = []; // Clear previous types
        this.produits = []; // Clear previous products
        try {
          const response = await axios.get(`https://scap.ma/api/category/${category.id}`);
          this.categoryTypes = response.data;
          if (this.isMobile) {
            this.showCategories = false;
            this.showCategoryTypes = true;
          }
          // Fetch products for each category type
          const productRequests = this.categoryTypes.map(async type => {
            const response = await axios.get(`https://scap.ma/api/produits/${type.id}`);
            type.produits = response.data;
          });
          await Promise.all(productRequests);
        } catch (error) {
          console.error(error);
        }
      },
      goBackToCategories() {
      if (this.isMobile) {
        this.showCategoryTypes = false;
        this.showCategories = true;
      }},

      goBack() {
    
    if (this.isMobile) {
      this.$emit('update:showDialog', false); // Emit an event to the parent
    }
  },
      show() {
        this.$emit('update:showDialog', true);
      },
    },
    mounted() {
      this.fetchCategories();
    },
  };
  </script>
  
  <style scoped>
  /* Add any custom styles here if needed */
  </style>